import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {    AddTutions, getLocationList, emailExist_check, tuitionEdit,
    tuitionReject, commonAPI } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX } from '../../constant.js';
import { Modal, ModalBody, Row, Col } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

const tuition_cls = [{"id":1,"name":"Class 1"},{"id":2,"name":"Class 2"},{"id":3,"name":"Class 3"},{"id":4,"name":"Class 4"},{"id":5,"name":"Class 5"},{"id":6,"name":"Class 6"},{"id":7,"name":"Class 7"},{"id":8,"name":"Class 8"},{"id":9,"name":"Class 9"},{"id":10,"name":"Class 10"},{"id":11,"name":"Class 11"},{"id":12,"name":"Class 12"},{"id":13,"name":"JEE"},{"id":14,"name":"NEET"},{"id":15,"name":"GATE"}];
const class_freq = [{"id":1,"freq_name":"Daily"},{"id":2,"freq_name":"Weekly"},{"id":3,"freq_name":"Monthly"},{"id":4,"freq_name":"NA"}];


class verticalTuitionEdit extends Component {

constructor(props) {
        super(props);
        this.state = {
            vendor_id: 1,
            pageid: '',
            owner_name: '',
            tution_name: '',
            email_id: '',
            languages_: [],
            phone_number: '',
            landline_number: '',
            fax_number: '',
            website: '',
            state: '',
            std_ratio: [],
            location: '',
            pincode: '',
            address: '',
            about_tution: '',
            google_location: '',
            subject: [],
            languageList: [],
            grade: '',
            number_of_teachers: '',
            timing: '',
            instruction_lang: '',
            establishment_Year: '',
            avg_anual_fee: '',
            addmission_fee: '',
            area: '',
            tutor_name: '',
            tution_type: [],
            class_range: [],
            board_of_education: [],
            class_frequency: '',
            country: '',
            images: '',
            photos: '',
            timingList: [],
            boeList: [],
            tutionList: [],
            subjectList: [],
            ClassList: class_freq,
            mopList: [],
            languages: false,
            getId: this.props.match.params.id ? this.props.match.params.id : '',
            latitude: '',
            longitude: '',
            other_rating: '',
            attachment_file: [],
            attachment_file_length: 0,
            attachment_fileName: [],
            from_time: '',
            from_time_cate: 'AM',
            to_time: '',
            to_time_cate: 'AM',
            edit_image: '',
            delete_array: [],
            location_list: [],
            keywords: [],
            tempBanner: '',
            has_trail: 0,
            trail_desc: '',
            partner_type: '',
            preview: false,
            edited_data: [],
            getTuitionCls: tuition_cls,
            keywordsArr: [],
            edited: false
        }
        this.validator = new SimpleReactValidator({
            validators: {
                checkExist: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (val === '' && this.state.edit_image === '') {
                            return false;
                        }
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                emailExist_check: {  // name the rule
                    message: 'The :attribute Already Exist.',
                    rule: (val, params, validator) => {
                        return this.state.isEmailValid;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                checkMobile: MOBILE_REGEX,
                checkUrl: URL_REGEX
            }
        });
        this.loadFile = this.loadFile.bind(this)
        //this.getTuitionCls(); 
        this.getKeywords();
        this.gettiming(); this.tutionList(); this.getSubject(); this.getlang(); this.getboe();
        //this.getclass_frequency(); 
        this.getpayment_type(); 
        this.getschool_type();
    }
    componentDidMount() {
        this.LocationDataList();
        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({
            login_id: vendor_id,
            role: auth_data.role,
        });

        if (this.state.getId) {
            this.getTutionsInfo();
        }
    }

    LocationDataList = async () => {
        try {
            const res = await getLocationList();
            if (res.status === 1) {
                console.log('location_list', res.results)

                this.setState({
                    location_list: res.results,
                    error: false
                });
            }

        } catch (error) {
            this.setState({ error: true });
        }
    };
    validateMail = (value, catgry, vendr_id, pageid) => {
        let name = 'email_id';
        let type_name = 'isEmailValid';
        let req = JSON.stringify({
            [name]: value,
            category: catgry,
            vendor_id: vendr_id,
            pageid: pageid
        });
        emailExist_check(req).then(res => {
            console.log('valuee', res);
            if (res.status === 1) {
                this.setState({
                    [type_name]: false
                });
            } else {
                // return res.status;
                this.setState({
                    [type_name]: true
                });
            }
        });
    }
  getKeywords = () => {
    commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'tuition' })).then((res) => {
      if (res.status === 1) {
        this.setState({
          keywordsArr: res.results
        })
      }
    })
  }
    async getTutionsInfo() {
        let response = await tuitionEdit(JSON.stringify({ id: this.state.getId }));
        // console.log(response);
        if (response.status === 1) {
            const data = response.data, edited_data = response.original;
            this.setState({
                owner_name: data.owner_name,
                pageid: data.id,
                tution_name: data.tution_name,
                email_id: data.email_id,
                phone_number: data.phone_number,
                landline_number: data.landline_number,
                website: data.website,
                state: data.state,
                location: data.location,
                pincode: data.pincode,
                address: data.address,
                about_tution: data.about,
                std_ratio: data.std_ratio.split(','),
                google_location: data.google_location,
                subject: data.sub_categories.split(','),
                number_of_teachers: data.no_teacher,
                instruction_lang: data.instruction_lang,
                establishment_Year: data.est_year,
                avg_anual_fee: data.avg_fee,
                addmission_fee: data.admit_fee,
                area: data.area,
                tutor_name: data.incharge_name,
                tution_type: data.tution_type ? data.tution_type.split(',') : [],
                class_range: data.class_range ? data.class_range.split(',') : [],
                board_of_education: data.bof ? data.bof.split(',') : [],
                class_frequency: data.class_freq ? data.class_freq.split(',') : [],
                country: data.country,
                images: data.images,
                photos: data.photos,
                languages_: data.languages ? data.languages.split(',') : [],
                languages: (data.languages) ? true : false,
                registration_no: data.registration_no,
                attachment_file: data.photo_arr,
                edit_image: data.images ? data.url + data.images : '',
                edit_photos: data.photos,
                keywords: data.keywords ? data.keywords.split(';') : [],
                from_time: data.from_time,
                to_time: data.to_time,
                from_time_cate: data.from_time_cate,
                to_time_cate: data.to_time_cate,
                has_trail: data.has_trail,
                trail_desc: data.trail_desc,
                other_rating: data.other_rating,
                longitude: data.longitude,
                latitude: data.latitude,
                partner_type: data.partner_type,
                edited: data.edited,
                edited_data: edited_data
            });
            this.Geocode_location(data.google_location);
        }
    }
    async tutionList() {
        let response = await FetchCall.getSchoolListDatas('tution_type');
        console.log(response);
        if (response) {
            this.setState({ tutionList: response.results });
        }
    }
    async gettiming() {
        let response = await FetchCall.getSchoolListDatas('timing');
        console.log(response);
        if (response) {
            this.setState({ timingList: response.results });
        }
    }
    async getSubject() {
        let response = await FetchCall.getSubCategory('6');
        console.log('subjectList', response);
        if (response) {
            this.setState({ subjectList: response.results });
        }
    }
    async getboe() {
        let response = await FetchCall.getSchoolListDatas('curriculum');
        console.log('boeList', response);
        if (response) {
            this.setState({ boeList: response.results });
        }
    }
    async getlang() {
        let response = await FetchCall.getSubCategory('101');
        if (response) {
            this.setState({ languageList: response.results });
        }
    }
    async getclass_frequency() {
        let response = await FetchCall.getSchoolListDatas('class_frequency');
        if (response) {
            this.setState({ ClassList: response.results });
        }
    }
    async getTuitionCls() {
        let response = await FetchCall.getSchoolListDatas('tuition_cls');
        if (response) {
            this.setState({ getTuitionCls: response.results });
        }
    }
    async getschool_type() {
        let response = await FetchCall.getSchoolListDatas('school_type');
        console.log(response);
        if (response) {
            this.setState({ schooltypeList: response.results });
        }
    }
    async getpayment_type() {
        let response = await FetchCall.getSchoolListDatas('payment_type');
        console.log(response);
        if (response) {
            this.setState({ mopList: response.results });
        }
    }

    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh');
    }
    onSelect = (selectedList) => {
        let keywords = [];
        selectedList.forEach((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    onRemove = (selectedList, removedItem) => {
        let keywords = [];
        selectedList.forEach((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);

        this.setState({ [propName]: value });

        if (propName === 'subject') {
            let filterValue = value.filter(item => item === '101')
            console.log('filterValue', filterValue)
            if (filterValue[0] === '101') {
                this.setState({
                    languages: true,
                    languages_: ''
                })
            } else {
                this.setState({ languages: false, sub_type: '' });
            }
        }
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name === 'google_location')
            this.Geocode_location();
    };


    handleFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            THIS.setState({
                tempBanner: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBanner: ''
            });
        }
    };

    handleFileMultiple = (e) => {
        this.setState({ [e.target.name]: e.target.files });
    };

    Geocode_location(location = '') {
        Geocode.fromAddress(location ? location : this.state.google_location).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                if (lat && lng)
                    this.get_location(lat, lng);
            },
            error => {
                console.error(error);
            }
        );

    }


    get_location(lat, lng) {
        this.setState({
            latitude: lat,
            longitude: lng
        });
    }
    removeImage = e => {
        var delete_array = this.state.delete_array;
        delete_array.push(e)
        const updated = this.state.attachment_file.filter(item => item.name !== e)
        this.setState({
            attachment_file: updated,
            delete_array: delete_array,
        })
    }

    remove_img() {
        jQuery('#edit_image').remove();
    }
    loadFile(e) {
        var files = e.target.files
        this.setState({ attachment_file_length: files.length })
        if (files.length > 0) {
            jQuery('.upload-space').addClass('hide')
            jQuery('.upload-thumb').removeClass('hide')
            var fileArra = this.state.attachment_file

            //console.log('fileArra',fileArra)
            //var fileThumbArra = this.state.imgThumb;
            for (var i = 0; i < files.length; i++) {
                fileArra.push(e.target.files[i])
                this.setState({
                    selectedFile: URL.createObjectURL(e.target.files[i]),
                    attachment_file: fileArra
                })
            }
            //   this.clearValidationErr('attachment_file');
        }
    }
    handlePreview = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                preview: true
            })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        const { edited_data, edited } = this.state;
        let languages = this.state.languages;
        this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Tuition Info Management</h4>
                                   
                   <div className="row">

                <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="">
                      <div id="company-info" className="tab-pane active">
                        <form onSubmit={this.handlePreview} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Partner Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.partner_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="partner_type"
                                                                    title='Select'>
                                                                    <option value='1'>Institution</option>
                                                                    <option value='2'>Individuals</option>
                                                                </select>
                                                                {this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.registration_no !== this.state.registration_no) && 'edited-field'}>
                                                                Registration No {this.state.user_type === 1 && <span className="astrick">*</span>}</label>
                                                            <input type="text"

                                                                value={this.state.registration_no}
                                                                onChange={this.handleChange}
                                                                name="registration_no" className="form-control" />
                                                            {
                                                                this.state.user_type === 1 &&
                                                                (
                                                                    this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
                                                                )
                                                            }

                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.owner_name !== this.state.ownerName) && 'edited-field'}>
                                                                Owner Name  {this.state.user_type === 1 && <span className="astrick">*</span>}</label>
                                                            <input type="text"

                                                                value={this.state.owner_name}
                                                                onChange={this.handleChange}
                                                                name="owner_name" className="form-control" />
                                                            {
                                                                this.state.user_type === 1 &&
                                                                (
                                                                    this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
                                                                )
                                                            }
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.tution_name !== this.state.tution_name) && 'edited-field'}>
                                                                Organization Name<span className="astrick">*</span></label>
                                                            <input type="text"

                                                                value={this.state.tution_name}
                                                                onChange={this.handleChange}
                                                                name="tution_name" className="form-control" />
                                                            {this.validator.message('Organization Name', this.state.tution_name, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.incharge_name !== this.state.tutor_name) && 'edited-field'}>
                                                                Incharge Name <span className="astrick">*</span></label>
                                                            <input type="text"

                                                                value={this.state.tutor_name}
                                                                onChange={this.handleChange}
                                                                name="tutor_name" className="form-control" />
                                                            {this.validator.message('Incharge Name', this.state.tutor_name, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.sub_categories !== this.state.subject) && 'edited-field'}>
                                                                Subject<span className="astrick">*</span></label>
                                                            <div className='custom-select-drop dropdown'>
                                                                <select
                                                                    value={this.state.subject}
                                                                    onChange={this.handleSelect}
                                                                    multiple
                                                                    className='form-control selectpicker' name="subject" title='Select'>
                                                                    {this.state.subjectList.length > 0 &&
                                                                        this.state.subjectList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.category_id} >
                                                                                    {item.category_name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Subject', this.state.subject, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        {languages === true &&
                                                            <div className="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.languages !== this.state.languages_) && 'edited-field'}>
                                                                    Languages<span className="astrick">*</span></label>
                                                                <div className='custom-select-drop dropdown'>
                                                                    <select
                                                                        value={this.state.languages_}
                                                                        onChange={this.handleSelect}
                                                                        multiple
                                                                        className='form-control selectpicker'
                                                                        name="languages_"
                                                                        title='Select'>
                                                                        {this.state.languageList.length > 0 &&
                                                                            this.state.languageList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.category_id} >
                                                                                        {item.category_name}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Languages', this.state.languages_, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Address Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.email_id !== this.state.email_id) && 'edited-field'}>
                                                                Email Id<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.email_id}
                                                                onChange={this.handleChange}
                                                                name="email_id" className="form-control" required/>
                                                            {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.phone_number !== this.state.phone_number) && 'edited-field'}>
                                                                Phone Number<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.phone_number}
                                                                onChange={this.handleChange} name="phone_number" className="form-control" required/>
                                                            {this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.landline_number !== this.state.landline_number) && 'edited-field'}>
                                                                Landline Number<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.landline_number}
                                                                onChange={this.handleChange} name="landline_number" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.website !== this.state.website) && 'edited-field'}>
                                                                Website<span className="astrick">*</span></label>

                                                            <input type="text"
                                                                value={this.state.website}
                                                                onChange={this.handleChange} name="website" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.state !== this.state.state) && 'edited-field'}>
                                                                State<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.state}
                                                                onChange={this.handleChange} name="state" className="form-control" />
                                                            {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.state !== this.state.state) && 'edited-field'}>
                                                                Location<span className="astrick">*</span></label>
                                                            <select
                                                                name="location"
                                                                id="location"
                                                                onChange={this.handleSelect}
                                                                value={this.state.location}
                                                                className="form-control selectpicker"
                                                                title='Select'
                                                            >
                                                                {this.state.location_list.length > 0 &&
                                                                    this.state.location_list.map((item, i) => {
                                                                        return (
                                                                            <option value={item.location} >
                                                                                {item.location}
                                                                            </option>
                                                                        )
                                                                    })}
                                                            </select>
                                                            {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.pincode !== this.state.pincode) && 'edited-field'}>
                                                                Pincode<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.pincode}
                                                                onChange={this.handleChange} name="pincode" className="form-control" />
                                                            {this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.address !== this.state.address) && 'edited-field'}>
                                                                Address<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.address}
                                                                onChange={this.handleChange} name="address" className="form-control" />
                                                            {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.google_location !== this.state.google_location) && 'edited-field'}>
                                                                Google Location Address<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.google_location}
                                                                onChange={this.handleChange} name="google_location" className="form-control" />
                                                            {this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.latitude !== this.state.latitude) && 'edited-field'}>
                                                                Latitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="latitude"
                                                                value={this.state.latitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.longitude !== this.state.longitude) && 'edited-field'}>
                                                                Longitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="longitude"
                                                                value={this.state.longitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.other_rating !== this.state.other_rating) && 'edited-field'}>
                                                                Google Rating
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step='0.01'
                                                                name="other_rating"
                                                                value={this.state.other_rating}
                                                                onChange={this.handleChange}
                                                                max='5'
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-12">
                                                            <label
                                                                className={edited && (edited_data.about !== this.state.about_tution) && 'edited-field'}>
                                                                About the Tution<span className="astrick">*</span></label>
                                                            <textarea type="text"
                                                                value={this.state.about_tution}
                                                                onChange={this.handleChange} name="about_tution" className="form-control" />
                                                            {this.validator.message('About', this.state.about_tution, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.tution_type !== this.state.tution_type) && 'edited-field'}>
                                                                Tution Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.tution_type}
                                                                    multiple
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="tution_type" title='Select'>
                                                                    {this.state.tutionList.length > 0 &&
                                                                        this.state.tutionList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Tution Type', this.state.tution_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.bof !== this.state.board_of_education) && 'edited-field'}>
                                                                Board Of Education<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.board_of_education}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="board_of_education" multiple title='Select'>
                                                                    {this.state.boeList.length > 0 &&
                                                                        this.state.boeList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Board Of Education', this.state.board_of_education, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.class_freq !== this.state.class_frequency) && 'edited-field'}>
                                                                Class Frequency<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    multiple
                                                                    value={this.state.class_frequency}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="class_frequency" title='Select'>
                                                                    {this.state.ClassList.length > 0 &&
                                                                        this.state.ClassList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.freq_name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Class Frequency', this.state.class_frequency, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.class_range !== this.state.class_range) && 'edited-field'}>
                                                                Class Range<span className="astrick">*</span></label>
                                                            <select className='form-control selectpicker' title='Select Class Range' multiple
                                                                value={this.state.class_range} name="class_range"
                                                                onChange={this.handleSelect}>
                                                                {this.state.getTuitionCls.map((item, i) => {
                                                                    return (
                                                                        <option value={item.id}>{item.name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            {this.validator.message('Class Range', this.state.class_range, 'required', { className: 'text-danger' })}
                                                            {/* <input type="text"
                                                                placeholder="Class 1 to Class 10"
                                                                value={this.state.class_range}
                                                                onChange={this.handleChange} className="form-control" name="class_range" /> */}
                                                            {/* {this.validator.message('Class Range', this.state.class_range, 'required', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.no_teacher !== this.state.number_of_teachers) && 'edited-field'}>
                                                                Number of Teachers<span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.number_of_teachers}
                                                                onChange={this.handleChange} className="form-control" name="number_of_teachers" />
                                                            {this.validator.message('Number of Teachers', this.state.number_of_teachers, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.instruction_lang !== this.state.instruction_lang) && 'edited-field'}>
                                                                Instruction Language</label>
                                                            <input type="text"
                                                                value={this.state.instruction_lang}
                                                                onChange={this.handleChange} name="instruction_lang" className="form-control" />
                                                            {this.validator.message('Instruction Language', this.state.instruction_lang, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <div>
                                                                <label
                                                                    className={edited && ((edited_data.from_time !== this.state.from_time) || edited_data.from_time_cate !== this.state.from_time_cate)
                                                                        && 'edited-field'}>From Timing</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.from_time}
                                                                        name="from_time"
                                                                        title='Select'
                                                                    >
                                                                        {this.state.timingList.length > 0 &&
                                                                            this.state.timingList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.id} >
                                                                                        {item.timing}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <label>&nbsp;</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.from_time_cate}
                                                                        name="from_time_cate"
                                                                    >
                                                                        <option value="AM">AM</option>
                                                                        <option value="PM">PM</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <div>
                                                                <label
                                                                    className={edited && ((edited_data.to_time !== this.state.to_time) || edited_data.to_time_cate !== this.state.to_time_cate)
                                                                        && 'edited-field'}>To Timing</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.to_time}
                                                                        name="to_time"
                                                                        title='Select'
                                                                    >
                                                                        {this.state.timingList.length > 0 &&
                                                                            this.state.timingList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.id} >
                                                                                        {item.timing}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <label>&nbsp;</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.to_time_cate}
                                                                        name="to_time_cate"
                                                                    >
                                                                        <option value="AM">AM</option>
                                                                        <option value="PM">PM</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.est_year !== this.state.establishment_Year) && 'edited-field'}>
                                                                Establishment Year <span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.establishment_Year}
                                                                onChange={this.handleChange} name="establishment_Year" className="form-control" />
                                                            {this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Establishment Year', this.state.establishment_Year, 'required|numeric|min:4|max:4', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.avg_fee !== this.state.avg_anual_fee) && 'edited-field'}>
                                                                Average Fees(INR) <span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.avg_anual_fee}
                                                                onChange={this.handleChange} name="avg_anual_fee" className="form-control" />
                                                            {this.validator.message('Average Fees', this.state.avg_anual_fee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.admit_fee !== this.state.addmission_fee) && 'edited-field'}>
                                                                Admission Fees <span className="astrick">*</span></label>
                                                            <input type="text"
                                                                value={this.state.addmission_fee}
                                                                onChange={this.handleChange} name="addmission_fee" className="form-control" />
                                                            {this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.std_ratio !== this.state.std_ratio) && 'edited-field'}>
                                                                Student Ratio<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.std_ratio}
                                                                    name="std_ratio"
                                                                    id="std_ratio"
                                                                    onChange={this.handleSelect}
                                                                    className="form-control selectpicker"
                                                                    multiple
                                                                    title='Select'
                                                                >
                                                                    <option value='1' >
                                                                        One to One
                                                                    </option>
                                                                    <option value='2' >
                                                                        One to Many
                                                                    </option>
                                                                    <option value='3' >
                                                                        NA
                                                                    </option>
                                                                </select>
                                                                {this.validator.message('Student Ratio', this.state.std_ratio, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.has_trail !== this.state.has_trail) && 'edited-field'}>
                                                                Is Free Trial Available? <span class="astrick">*</span></label>
                                                            <select
                                                                className='form-control selectpicker'
                                                                name='has_trail'
                                                                value={this.state.has_trail}
                                                                title='Select'
                                                                onChange={this.handleSelect}>
                                                                <option value='0'>NA</option>
                                                                <option value='1'>Yes</option>
                                                                <option value='2'>No</option>
                                                            </select>
                                                            {this.validator.message('Free Trial', this.state.has_trail, 'required', { className: 'text-danger error-msg' })}

                                                        </div>
                                                        {(this.state.has_trail === 1 && (
                                                            <div class="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.trail_desc !== this.state.trail_desc) && 'edited-field'}>
                                                                    Free Trial Description <span class="astrick">*</span></label>
                                                                <textarea className="form-control" name='trail_desc' onChange={this.handleChange} value={this.state.trail_desc}></textarea>
                                                                {this.validator.message('Free Trial Descrption', this.state.trail_desc, 'required', { className: 'text-danger error-msg' })}
                                                            </div>
                                                        ))}
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.keywords !== this.state.keywords) && 'edited-field'}>
                                                                Keywords<span className="astrick">*</span></label>
                                                            <Multiselect
                                                                isObject={false}
                                                                options={this.state.keywordsArr} // Options to display in the dropdown
                                                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                                                onSelect={this.onSelect} // Function will trigger on select event
                                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                            />
                                                            {/* <textarea
                                                                name="keywords"
                                                                value={this.state.keywords}
                                                                onChange={this.handleChange}
                                                                className="form-control"
                                                                placeholder="ex: school,category names,location name,etc"
                                                            ></textarea> */}
                                                            {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.images !== this.state.images) && 'edited-field'}>
                                                                Banner Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="images"
                                                                onChange={this.handleFile}
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })}
                                                            {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                        {(this.state.edit_image !== '' || this.state.tempBanner !== '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                                                    <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }
                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label
                                                                className={edited && (edited_data.photos !== this.state.photos) && 'edited-field'}>
                                                                Gallery Images <span className="astrick">*</span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-12 float-left mt-4 p-0">

                                                            <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                                                <div className='upload-wizard'>
                                                                    <div className='upload-thumb'>
                                                                        <ul className='list-inline'>
                                                                            {this.state.attachment_file.map((file_data, index) => {


                                                                                var file_url;
                                                                                if (file_data.name) {
                                                                                    let url = file_data.image_thumb ? file_data.image_thumb : '';
                                                                                    if (url !== '') {
                                                                                        file_url = file_data.image_thumb;
                                                                                    } else {
                                                                                        file_url = URL.createObjectURL(file_data);
                                                                                    }
                                                                                    // var file_url = URL.createObjectURL(file_data)
                                                                                    // var file_name = file_data.name
                                                                                    if (file_data.type === 'application/pdf') {                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='preview'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_name}</span> */}
                                                                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                                                                    this.removeImage(file_data.name)
                                                                                                }}>
                                                                                                    <img
                                                                                                        src={'../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='preview'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                                                                <a
                                                                                                    href='javascript:;'
                                                                                                    className='del-btn'
                                                                                                    onClick={() => {
                                                                                                        this.removeImage(file_data.name)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={'../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                                return;
                                                                            })}
                                                                            <li className='addMore'>
                                                                                <input
                                                                                    type='file'
                                                                                    name='imgInp[]'
                                                                                    id='imgInp2'
                                                                                    className='add_img'
                                                                                    multiple
                                                                                    onChange={this.loadFile.bind(this)}
                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                />
                                                                                <a href='javascript:;' className='add-more'>
                                                                                    <div>
                                                                                        <img src={'../assets/images/upload-icon.svg'} alt='icon' />
                                                                                        Add more
                                                                                    </div>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-xs-12 btn-bdr">
                                                    <button className="btn btn-primary btn-sm">Preview</button>
                                                </div>
                                            </form>
                    </div>
                  </div>
                </div>
              </div>  


                </div>
              </div>
            </div>

             {this.preview()}

            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
preview = () => {
        let subcate = this.state.subjectList.map((item) =>
            this.state.subject.includes(item.category_id.toString()) ? item.category_name : ''
        );
        subcate = subcate.filter(n => n).toString();
        let lang = this.state.languageList.map((item) =>
            this.state.languages_.includes(item.category_id.toString()) ? item.category_name : ''
        );
        lang = lang.filter(n => n).toString();
        let ttype = this.state.tutionList.map((item) =>
            this.state.tution_type.includes(item.id.toString()) ? item.name : ''
        );
        ttype = ttype.filter(n => n).toString();
        let boe = this.state.boeList.map((item) =>
            this.state.board_of_education.includes(item.id.toString()) ? item.name : ''
        );
        boe = boe.filter(n => n).toString();
        let cls = this.state.getTuitionCls.map((item) =>
            this.state.class_range.includes(item.id.toString()) ? item.name : ''
        );
        cls = cls.filter(n => n).toString();
        let loptions = this.state.std_ratio.map((item) => {
            if (item === 1) {
                return 'One to One';
            }
            if (item === 2) {
                return 'One to Many';
            }
            if (item === 3) {
                return 'NA';
            }
            return;
        }
        );
        loptions = loptions.filter(n => n).toString();
        let clsfreq = this.state.ClassList.map((item) => {
            if (this.state.class_frequency === item.id.toString())
                return item.freq_name;
            return;
        });
        let from_time = this.state.timingList.map((item) => {
            if (item.id === this.state.from_time) return item.timing
            return;
        })
        from_time = from_time.filter(n => n).toString();
        let to_time = this.state.timingList.map((item) => {
            if (item.id === this.state.to_time) return item.timing
            return;
        })
        to_time = to_time.filter(n => n).toString();
        return (
            <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
                <ModalBody className=''>
                    <Row>
                        <Col md='12'>
                            <img src='/assets/images/user-header.png' className='preview-header' alt="preview" />
                        </Col>
                    </Row>
                    <Row className='pv-banner'>
                        <Col className='pv-banner-bg' md='12'>
                            <div className='title-section'>
                                <p className="banner-title">{this.state.organisation_name}</p>
                                <p className="banner-address">{this.state.address}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>About the School</h4>
                                <p className="">{this.state.about}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Key Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Class</b></div>
                                        <div className='key-po'>
                                            <p>{cls}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Avg Fee</b></div>
                                        <div className='key-po'>
                                            <p>{parseFloat(this.state.avg_anual_fee) > 0 ? `${this.state.avg_anual_fee}/Month` : 'NA'}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Learning at</b></div>
                                        <div className='key-po'>
                                            <p>{ttype}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Board of Education</b></div>
                                        <div className='key-po'>
                                            <p>{boe}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Instruction language</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.instruction_lang}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Subject</b></div>
                                        <div className='key-po'>
                                            <p>{subcate}</p>
                                        </div>
                                    </div>
                                    {lang && (
                                        <div className='col-md-4'>
                                            <div className='type-n7ngd'><b>Languages</b></div>
                                            <div className='key-po'>
                                                <p>{lang}</p>
                                            </div>
                                        </div>
                                    )}

                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>No of Staff</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {this.state.number_of_teachers}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Timing</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {from_time === 'NA' || to_time === 'NA' ? 'NA' :
                                                    `${from_time} ${this.state.from_time_cate} - ${to_time} ${this.state.to_time_cate}`}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Establishment Year</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.establishment_Year}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Student Ratio</b></div>
                                        <div className='key-po'>
                                            <p>{loptions}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Class Frequency</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {clsfreq}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Free Trial Class</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {this.state.has_trail === 0 ? 'NA' :
                                                    (this.state.has_trail === 1 ? 'Yes, ' : 'No')}
                                                {this.state.has_trail === 1 && (` ${this.state.trail_desc}`)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Gallery</h4>
                                <div className='row'>
                                    {this.state.attachment_file.map((item) => {
                                        if (item.image_thumb) {
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={item.image_thumb} className='preview-image' alt="preview" />
                                                </div>
                                            )
                                        } else if (item.name) {
                                            let file_url = URL.createObjectURL(item);
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={file_url} className='preview-image' alt="preview"/>
                                                </div>
                                            )
                                        }
                                    })}
                                    {this.state.attachment_file.length === 0 && (
                                        <div className='col-md-4'>No Gallery Images Found</div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Contact Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        Email Id : {this.state.email_id}
                                    </div>
                                    <div className='col-md-4'>
                                        Contact : {this.state.phone_number}
                                    </div>
                                    <div className='col-md-4'>
                                        Website : {this.state.website}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                                {this.state.edited && (this.state.role === 1 || this.state.login_id === 936) ? 'Approve' : 'Submit'}
                            </button>
                            {this.state.edited && (this.state.role === 1 || this.state.login_id === 936) && (
                                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                                    onClick={this.handleReject}>
                                    Reject
                                </button>
                            )}
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ preview: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >
        )
    }
    handleReject = (e) => {
        e.preventDefault();
        let req = JSON.stringify({
            id: this.state.getId
        })
        let toastr = '';
        tuitionReject(req).then((res => {
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
                window.location.href = document.referrer;
            }
        }))
    }
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            let insData = {
                gid: this.state.getId,
                login_id: this.state.login_id,
                owner_name: this.state.owner_name,
                tution_name: this.state.tution_name,
                email_id: this.state.email_id,
                phone_number: this.state.phone_number,
                landline_number: this.state.landline_number,
                website: this.state.website,
                state: this.state.state,
                location: this.state.location,
                pincode: this.state.pincode,
                address: this.state.address,
                about: this.state.about_tution,
                google_location: this.state.google_location,
                sub_categories: this.state.subject,
                no_teacher: this.state.number_of_teachers,
                opening_time: this.state.timing,
                instruction_lang: this.state.instruction_lang,
                est_year: this.state.establishment_Year,
                avg_fee: this.state.avg_anual_fee,
                admit_fee: this.state.addmission_fee,
                area: this.state.area,
                incharge_name: this.state.tutor_name,
                tution_type: this.state.tution_type,
                class_range: this.state.class_range,
                bof: this.state.board_of_education,
                class_freq: this.state.class_frequency,
                country: this.state.country,
                images: this.state.images,
                languages: this.state.languages_,
                registration_no: this.state.registration_no,
                photos: this.state.attachment_file,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                std_ratio: this.state.std_ratio,
                from_time: this.state.from_time,
                to_time: this.state.to_time,
                keywords: this.state.keywords ? this.state.keywords.join(';') : '',
                from_time_cate: this.state.from_time_cate,
                to_time_cate: this.state.to_time_cate,
                delete_array: this.state.delete_array,
                has_trail: this.state.has_trail,
                trail_desc: this.state.trail_desc,
                other_rating: this.state.other_rating,
                partner_type: this.state.partner_type,
                role: this.state.role
            }
            // jQuery("#btnSubmit").attr('disabled', true);
            AddTutions(insData).then((res) => {
                if (res.status === 1) {
                    alert("Saved successfully");
                    window.location.href = document.referrer;
                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    alert("Error in saving");
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };


}

export default verticalTuitionEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalTuitionEdit.jsx